
<main>
  <div class="container">
    <div class="px-3 py-5 pt-md-5 pb-md-4 mx-auto text-center d-flex flex-column align-items-center">
      <h1 class="text-primary">404</h1>
      <h2>La página que esta buscando no existe</h2>
      <a mat-button color="primary" [routerLink]="['/']" class="mt-3 a-35">Ir al inicio</a>
    </div>
  </div>
</main>
